import { createStore } from 'vuex'
import axios from 'axios'
import qs from 'qs'

export default createStore({
  state: {
    loaded: false,
    testimonials: [],
    currentPage: 1,
    itemsPerPage: 10, // 10
    numberOfPages: 1,
    numberOfTotalItems: 0
  },
  getters: {
    getParams: (state) => {
      const params = {
        currentPage: state.currentPage,
        itemsPerPage: state.itemsPerPage,
        link: { notEmpty: 1 }
      }
      return params
    }
  },
  mutations: {
    setLoaded (state, payload) {
      state.loaded = payload
    },
    setTestimonials (state, payload) {
      state.testimonials = payload
    },
    addTestimonials (state, payload) {
      state.testimonials = [...state.testimonials, ...payload]
    },
    increaseCurrentPage (state) {
      state.currentPage += 1
    },
    setNumberOfPages (state, payload) {
      state.numberOfPages = payload
    },
    setNumberOfTotalItems (state, payload) {
      state.numberOfTotalItems = payload
    }
  },
  actions: {
    async getTestimonials ({ commit, getters, state }) {
      commit('setLoaded', false)
      try {
        const response = await axios.get(window.app.testimonials_list.api_base + 'testimonials-testimonials' + '/?' + qs.stringify(getters.getParams))
        state.currentPage === 1
          ? commit('setTestimonials', response.data.testimonials)
          : commit('addTestimonials', response.data.testimonials)
        commit('setNumberOfPages', response.data.numberOfPages)
        commit('setNumberOfTotalItems', response.data.numberOfTotalItems)
        commit('setLoaded', true)
        return response
      } catch (e) {
        commit('setErrors', e, { root: true })
      }
    },
    async increasePage ({ commit }) {
      commit('increaseCurrentPage')
    }
  },
  modules: {}
})
